import { SegmentedControl } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { useOnlyMine } from "../lib/onlyMine.js";

/**
 * „Meine Kunden" / „Mein Bereich" — sichtbar nur, wenn es beide gibt.
 *
 * Steht auf dem Dashboard und auf den Seiten, auf die die Kacheln führen
 * (Termine, Wartung), damit man dort weiterschalten kann, ohne zurück zum
 * Dashboard zu müssen. Zustand und Voreinstellung: `useOnlyMine`.
 */
export function OnlyMineSwitch() {
  const { t } = useTranslation();
  const { onlyMine, setOnlyMine, umschaltbar } = useOnlyMine();
  if (!umschaltbar) return null;
  return (
    <SegmentedControl
      size="xs"
      value={onlyMine ? "mine" : "segment"}
      onChange={(v) => setOnlyMine(v === "mine")}
      aria-label={t("common.onlyMine.label")}
      data={[
        { label: t("common.onlyMine.mine"), value: "mine" },
        { label: t("common.onlyMine.segment"), value: "segment" },
      ]}
    />
  );
}
